import InfiniteScroll from "react-infinite-scroll-component";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import EndPoints from "src/Constants/EndPoints";
import useAuth from "src/Hooks/Custom/useAuth";
import useLoading from "src/Hooks/Custom/useLoading";
import useApiFetchInfinite from "src/Hooks/Shared/useApiFetchInfinite";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import { useTranslation } from "react-i18next";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { useState } from "react";

function ContactsModal({ showModal, setChatData, setModalVisibility }: any) {
  const { user } = AppStateHandler.getState();
  const history = useHistory()
  const { path } = useRouteMatch();
  const { loading } = useAuth();
  const [search, setSearch] = useState<string>('')
  const { t, i18n } = useTranslation();
  const { data, refetch, status, fetchMore } = useApiFetchInfinite([EndPoints.contacts + "?subId=" + user?.username], {
    getFetchMore: (lastData) => {
      const nextPage = lastData?.data?.Page;
      const totalPages = lastData?.data?.TotalPages;

      return parseInt(nextPage ?? "1", 10) < totalPages
        ? `&page=${parseInt(nextPage ?? "1", 10) + 1}`
        : null;
    },
  });
  useLoading(status);

  if (data?.length === 0 && status === "loading") {
    return (
      <VisibilityToggle visible={loading}>
        <span className="spinner-border spinner-border-lg"></span>
      </VisibilityToggle>
    );
  }

  const arrayData = (Array.isArray(data) ? data : [])
    .map((_) => _.data.Items)
    .reduce((a, b) => a.concat(b), []);

  const handleChat = (receiver: any) => {
    const chatData = {
      senderId: user.username,
      senderName: user.name + ' ' + user.family_name,
      senderImage: user.picture,
      receiverId: receiver.subId,
      receiverName: receiver.name + ' ' + receiver.family_name,
      receiverImage: receiver.picture
    }
    history.push(path);
    setChatData(chatData);
    setModalVisibility(false);
  }

  return (
    <>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="confirm_post"
        style={{ display: showModal ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-4 custom_modal">
              <InfiniteScroll
                dataLength={arrayData.length} //This is important field to render the next data
                next={fetchMore}
                hasMore={true}
                loader={
                  <VisibilityToggle visible={loading}>
                    <span className="spinner-border spinner-border-lg"></span>
                  </VisibilityToggle>
                }
                endMessage={
                  <p className="text-center">
                    <b>Yay! You have seen it all</b>
                  </p>
                }
                // below props only if you need pull down functionality
                refreshFunction={refetch}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={
                  <h3 className="text-center">&#8595; Pull down to refresh</h3>
                }
                releaseToRefreshContent={
                  <h3 className="text-center">&#8593; Release to refresh</h3>
                }
              >
                <div className="d-flex justify-content-between mb-2 align-items-center px-3">
                  <h3 className="fz16 mb-0 mr-3">
                    <i className={` fa  cursor-pointer ${i18n.dir()==='rtl'?'ml-2 fa-arrow-right ':'mr-2 fa-arrow-left '}`} onClick={() => setModalVisibility(false)} aria-hidden="true"></i>

                    {t('Message')}
                  </h3>
                  <div className="d-flex align-items-center w-70 position-relative">
                    <input
                      type="text"
                      className={`form-control fz12 custom_input border-0 ${i18n.dir()==='rtl'?'Almarairegular':' poppinsregular'}`}
                      placeholder={t("Search")}
                      onChange={e => setSearch(e.target.value)}
                    />
                    <i className={` fa fa-search ${i18n.dir()==='rtl'?'fa-search-rtl':'fa-search-ltr'}`} style={{ bottom: '17px' }}></i>
                  </div>
                </div>
                <div className="furniture_section">
                  <div className="container-fluid">
                    <div className="row mt-4">
                      <div className="col-md-12">
                        <div className="col_selector">
                          {
                            arrayData.filter((user: any) => {
                              return user.name.toLowerCase().includes(search.toLowerCase()) || user.family_name.toLowerCase().includes(search.toLowerCase())

                            }).map((user: any) => {
                              return (
                                <>
                                  <Link to={path + "/new"} onClick={() => handleChat(user)} >
                                    <div className={`d-flex justify-content-between position-relative ${i18n.dir()==='rtl'?'pr-5':'pl-5'} cursor-pointer`}>
                                      <div className={`message_user_icon ${i18n.dir()==='rtl'?'message_user_icon_posRTL':'message_user_icon_posLTR'}`}>
                                        <img src={user.picture && user.picture !== "" ? user.picture : "/assets/images/profile-camera.png"} className="rounded-circle" width="39" height="40" alt="" />
                                      </div>
                                      <div style={{ paddingTop: '12px' }}>
                                        <h4 className="fz14 mb-1 pl-3">{user.name + ' ' + user.family_name}</h4>
                                      </div>
                                    </div>
                                  </Link>
                                  <hr />
                                </>
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={showModal ? true : false}>
        <div
          className={`modal-backdrop fade ${showModal ? "show" : ""}`}
          onClick={() => setModalVisibility(false)}
        ></div>
      </VisibilityToggle>
    </>
  );
}
export default ContactsModal;
